const ProgressBar: React.FC<{ value: number; max: number; showLabels?: boolean }> = ({ value, max, showLabels = true }) => {
  const pct = Math.max(0, Math.min(100, (value / Math.max(1, max)) * 100))
  const pctInt = Math.floor(pct)
  return (
    <div className="w-full">
      {showLabels && (
        <div className="flex items-center justify-between text-[11px] text-gray-500 mb-1">
          <span>0</span>
          <span>{max.toLocaleString()}</span>
        </div>
      )}
      <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
        <div className="h-full bg-black/80" style={{ width: `${pct}%` }} />
        {/* marker dot */}
        <div className="absolute top-1/2 -translate-y-1/2" style={{ left: `calc(${pct}% - 6px)` }} aria-hidden>
          <div className="h-3 w-3 rounded-full bg-black/80 shadow" />
        </div>
      </div>
      <div className="mt-1 text-[11px] text-gray-600">
        <span className="font-medium">{value.toLocaleString()}</span>
        <span className="mx-1">/</span>
        <span>{max.toLocaleString()} points</span>
        <span className="ml-2 text-gray-500">({pctInt}%)</span>
      </div>
    </div>
  )
}

const MeCard: React.FC<{
  mana: number
  rank?: number | null
  minToClaim?: number
  canClaim?: boolean
  onClaim?: () => void
  claims?: any[]
}> = ({ mana, rank, minToClaim = 2000, claims }) => {
  return (
    <div className="rounded-2xl border p-4 shadow-sm bg-white">
      <div className="grid grid-cols-2 gap-4 mt-4">
        <div className="rounded-xl border p-3">
          <div className="text-xs text-gray-500">Your Points</div>
          <div className="text-xl font-semibold">{mana.toLocaleString()}</div>
        </div>
        <div className="rounded-xl border p-3">
          <div className="text-xs text-gray-500">Your Rank</div>
          <div className="text-xl font-semibold">#{rank?.toLocaleString() ?? 0}</div>
        </div>
      </div>
      <div className="mt-4 gap-2">
        <ProgressBar value={mana} max={minToClaim * ((claims?.length || 0) + 1)} />
        <div className="text-xs text-gray-500 self-center">You can claim once you hit the {minToClaim * ((claims?.length || 0) + 1)} points.</div>
      </div>
    </div>
  )
}
export default MeCard
